import {HeaderNavbarMobileWrapperDefaultBox} from "./header-navbar-mobile-wrapper.default.box";

export const HeaderNavbarMobileWrapperBox = HeaderNavbarMobileWrapperDefaultBox;
